import React from "react"
import * as styles from "./footer-table-menu.module.scss"
import { FooterMenuFieldsFragment } from "../../../../../graphql-types"

type RenderProps = {
  data: FooterMenuFieldsFragment
}

const FooterTableMenu: React.FC<RenderProps> = ({ data }) => {
  function _getTableMenuColumnNbr(): number {
    let colNbr: number = 0
    if (data.label && data.column1.length != 0) colNbr++
    if (data.label2 && data.column2.length != 0) colNbr++
    if (data.label3 && data.column3.length != 0) colNbr++
    if (data.label4 && data.column4.length != 0) colNbr++
    if (data.label5 && data.column5.length != 0) colNbr++
    return colNbr
  }

  function _menuItemValidator(displayMainMenu, subMenu) {
    let isSubMenu: boolean = false

    for (let index = 0; index < subMenu.length; index++) {
      if (subMenu[index].footerDisplay) isSubMenu = true
    }
    if (!displayMainMenu && !isSubMenu) return false
    return true
  }

  function _buildMenuItem(
    mainMenuLabel,
    mainMenuPage,
    displayMainMenu,
    subMenu,
    i
  ) {
    if (_menuItemValidator(displayMainMenu, subMenu) == false) {
      return null
    }
    return (
      <div className={styles.tableMenuItem}>
        {displayMainMenu && mainMenuPage ? (
          <h3 className={styles.footerElementTitle}>
            <a
              id={"footerMainMenuLabel" + "Number" + i}
              href={"/" + mainMenuPage.slug}
            >
              <div className={styles.tableMenuLabel}>{mainMenuLabel}</div>
            </a>
          </h3>
        ) : displayMainMenu && mainMenuLabel ? (
          <h3 className={styles.footerElementTitle}>
            <div className={styles.tableMenuLabel}>{mainMenuLabel}</div>
          </h3>
        ) : null}
        <ul className={styles.footerListElement}>
          {subMenu.map((subMenuItem, index) => {
            const link =
              (subMenuItem.page && `/${subMenuItem.page.slug}`) ||
              subMenuItem.externalPage
            return subMenuItem.footerDisplay ? (
              <li
                className={styles.footerListElement}
                key={`subMenuLabel${i + index}`}
              >
                <a
                  key={subMenuItem.label}
                  className={styles.tableMenuSubLabel}
                  href={link}
                >
                  {subMenuItem.label}
                </a>
              </li>
            ) : null
          })}
        </ul>
      </div>
    )
  }

  return (
    <div
      style={
        _getTableMenuColumnNbr() > 3
          ? { left: "0" }
          : { justifyContent: "space-evenly" }
      }
      className={styles.tableMenu}
    >
      {_buildMenuItem(
        data.label,
        data.page,
        data.footerDisplay1,
        data.column1,
        0
      )}
      {_buildMenuItem(
        data.label2,
        data.page2,
        data.footerDisplay2,
        data.column2,
        1
      )}
      {_buildMenuItem(
        data.label3,
        data.page3,
        data.footerDisplay3,
        data.column3,
        2
      )}
      {_buildMenuItem(
        data.label4,
        data.page4,
        data.footerDisplay4,
        data.column4,
        3
      )}
      {_buildMenuItem(
        data.label5,
        data.page5,
        data.footerDisplay5,
        data.column5,
        4
      )}
    </div>
  )
}

export default FooterTableMenu
